import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withFormik, Field, Form, getIn } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col } from 'react-bootstrap';

import { FormikInput, InputSelect, NestedAttributes, RegionCommune, PhoneWithCode } from '../../components';
import { debounceIndexEmployeesRequest, indexEmployeesRequest } from '../../requests/employees';
import { rutFormat, validRutInput } from '../../services/utils';

const EmployeeSyndicateInput = ({
  defaultOptions,
  defaultValue,
  employeesRequest,
  errors,
  touched,
  index,
  setFieldValue
}) => (
  <>
    <Col md={6}>
      <Field name={`syndicate[employeeSyndicatesAttributes][${index}][employeeId]`}>
        {({ field }) => (
          <InputSelect
            {...field}
            abbr
            label="Empleado"
            placeholder="Seleccionar Empleado"
            defaultOptions={defaultOptions}
            value={defaultValue}
            request={employeesRequest}
            onChange={data => setFieldValue(field.name, data.value)}
            error={getIn(errors, field.name)}
            touched={getIn(touched, field.name)}
          />
        )}
      </Field>
    </Col>
    <Col md={5}>
      <Field name={`syndicate[employeeSyndicatesAttributes][${index}][jobTitle]`}>
        {({ field }) => (
          <FormikInput
            {...field}
            label="Cargo"
            error={getIn(errors, field.name)}
            touched={getIn(touched, field.name)}
          />
        )}
      </Field>
    </Col>
  </>
);

class SyndicateForm extends Component {
  state = {
    initialEmployees: []
  };

  componentDidMount() {
    this.fetchInitialEmployees();
  }

  addEmployee = () => {
    const { initialEmployees } = this.state;
    const { errors, touched, values, setFieldValue } = this.props;
    const { syndicate } = values;
    const { employeeSyndicatesAttributes } = syndicate;

    const mapResults = employeeSyndicatesAttributes.map((body, index) => {
      if (body._destroy) {
        return undefined;
      }

      const defaultValue = this.initialEmployeeValue(body);
      return (
        <EmployeeSyndicateInput
          key={`employee-${index.toString()}`}
          defaultOptions={initialEmployees}
          defaultValue={defaultValue}
          employeesRequest={this.fetchEmployees}
          errors={errors}
          touched={touched}
          index={index}
          setFieldValue={setFieldValue}
        />
      );
    });

    mapResults.push(
      <>
        <Col md={6} className="sample-row">
          <InputSelect label="Empleado" placeholder="Seleccionar Empleado" isDisabled />
        </Col>
        <Col md={5} className="sample-row">
          <FormikInput label="Cargo" disabled />
        </Col>
      </>
    );

    return (
      <>
        <NestedAttributes
          removeFirstItem
          mapInputs={mapResults}
          arrayValues={employeeSyndicatesAttributes}
          setFieldValue={setFieldValue}
          valuePath="syndicate[employeeSyndicatesAttributes]"
          newAttributes={{ employeeId: '', jobTitle: '' }}
        />
      </>
    );
  };

  fetchInitialEmployees = () => {
    const { dispatch } = this.props;
    indexEmployeesRequest({
      dispatch,
      params: {
        sort_column: 'name',
        paginate: false,
        is_dt: false,
        active: true
      },
      successCallback: response => {
        this.setState({ initialEmployees: response.data.data });
      }
    });
  };

  fetchEmployees = (inputValue, callback) => {
    const { dispatch } = this.props;
    debounceIndexEmployeesRequest({
      dispatch,
      params: {
        query: inputValue,
        sort_column: 'name',
        is_dt: false,
        paginate: false
      },
      successCallback: response => {
        callback(response.data.data);
      }
    });
  };

  initialEmployeeValue = value => {
    const { syndicate } = this.props;
    const { employeeSyndicatesAttributes: attributes } = syndicate;

    if (value && value.id) {
      const vAttribute = attributes.filter(e => {
        return value.employeeId === e.employeeId;
      });

      if (vAttribute.length) {
        return { label: vAttribute[0].fullName, value: value.employeeId };
      }
    }
    return undefined;
  };

  render() {
    const { onHide, submitVariant, errors, touched, action, values, setFieldValue, isSubmitting } = this.props;
    const btnMessage = action === 'new' ? 'Crear' : 'Guardar';
    const {
      syndicate: { phoneCountryCode }
    } = values;

    const handleIdentificationNumberFormat = e => {
      if (validRutInput(e)) {
        const formattedValue = rutFormat(e.target.value);
        setFieldValue(e.target.name, formattedValue);
      }
    };

    return (
      <Form>
        <Row>
          <Col md={3}>
            <Field name="syndicate[code]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  abbr
                  label="Código"
                  onBlur={() => setFieldValue(field.name, values.syndicate.code.trim())}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <Col md={3}>
            <Field name="syndicate[identificationNumber]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  abbr
                  label="Rut"
                  onChange={e => handleIdentificationNumberFormat(e)}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <Col md={6}>
            <Field name="syndicate[name]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  abbr
                  label="Nombre"
                  onBlur={() => setFieldValue(field.name, values.syndicate.name.trim())}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <Col md={6}>
            <Field name="syndicate[address]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  label="Dirección"
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <Col md={2}>
            <Field name="syndicate[addressNumber]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  label="Número"
                  inputType="number"
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <Col md={2}>
            <Field name="syndicate[addressFloor]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  label="Piso"
                  inputType="number"
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <Col md={2}>
            <Field name="syndicate[addressOffice]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  label="Oficina"
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <RegionCommune modelKey="syndicate" />
          <Col md={6}>
            <PhoneWithCode
              label="Teléfono"
              countryCodeField="syndicate[phoneCountryCode]"
              phoneField="syndicate[phone]"
              workPhoneCountryCode={phoneCountryCode}
              errors={errors}
              touched={touched}
              setFieldValue={setFieldValue}
            />
          </Col>
        </Row>
        <h4 className="text-uppercase">Miembros</h4>
        {this.addEmployee()}

        <Row className="d-flex justify-content-end my-3">
          <Col md={3}>
            <Button
              type="submit"
              className="mb-5"
              disabled={isSubmitting}
              variant={submitVariant}
              block
              onClick={onHide}
            >
              {btnMessage}
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const setInitialValues = props => {
  const { syndicate } = props;

  return { syndicate };
};

const validationSchema = Yup.object().shape({
  syndicate: Yup.object().shape(
    {
      address: Yup.string()
        .max(120, 'Deben ser menos que 120 caracteres')
        .alphanumeric('Deben ser caracteres alfanuméricos')
        .nullable(),
      addressFloor: Yup.number().nullable(),
      addressNumber: Yup.number().nullable(),
      addressOffice: Yup.string()
        .max(120, 'Deben ser menos que 120 caracteres')
        .alphanumeric('Deben ser caracteres alfanuméricos')
        .nullable(),
      code: Yup.string()
        .required('Debes ingresar un código')
        .max(120, 'Deben ser menos que 120 caracteres')
        .alphanumeric('Deben ser caracteres alfanuméricos')
        .trim(),
      communeId: Yup.string().when('regionId', {
        is: val => val,
        then: Yup.string().required('Debes seleccionar una comuna'),
        otherwise: Yup.string().nullable()
      }),
      employeeSyndicatesAttributes: Yup.array().of(
        Yup.object().shape({
          jobTitle: Yup.string()
            .max(120, 'Deben ser menos que 120 caracteres')
            .alphanumeric('Deben ser caracteres alfanuméricos')
            .nullable(),
          employeeId: Yup.string().required('Debes ingresar un empleado')
        })
      ),
      identificationNumber: Yup.string()
        .required('Debes ingresar el rut')
        .rut('Debes ingresar un rut valido'),
      name: Yup.string()
        .trim('No puedes partir o terminar con espacios en blanco')
        .required('Debes ingresar un nombre')
        .max(120, 'Deben ser menos que 120 caracteres')
        .alphanumeric('Deben ser caracteres alfanuméricos'),
      phone: Yup.string()
        .when('phoneCountryCode', {
          is: val => val === '+56',
          then: Yup.string().length(9, 'Debe ser de 9 dígitos'),
          otherwise: Yup.string().min(3, 'Deben ser al menos 3 dígitos')
        })
        .nullable(),
      phoneCountryCode: Yup.string().when('phone', {
        is: val => val,
        then: Yup.string().required('Debes seleccionar un código'),
        otherwise: Yup.string().nullable()
      }),
      regionId: Yup.number().nullable()
    },
    [['phone', 'phoneCountryCode']]
  )
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: props => setInitialValues(props),
  validationSchema,
  handleSubmit,
  enableReinitialize: true,
  validateOnMount: props => props.action !== 'new'
})(connect()(SyndicateForm));
